import { denormalisedResponseEntities } from '../../../util/data';
import { storableError } from '../../../util/errors';
import { types as sdkTypes } from '../../../util/sdkLoader';
import { post } from '../../../util/api'; // Added import for post utility
const { UUID } = sdkTypes;

// ================ Action types ================ //

export const FETCH_LINE_ITEMS_REQUEST = 'app/ShoppingCart/FETCH_LINE_ITEMS_REQUEST';
export const FETCH_LINE_ITEMS_SUCCESS = 'app/ShoppingCart/FETCH_LINE_ITEMS_SUCCESS';
export const FETCH_LINE_ITEMS_ERROR = 'app/ShoppingCart/FETCH_LINE_ITEMS_ERROR';

export const SEND_ENQUIRY_REQUEST = 'app/ShoppingCart/SEND_ENQUIRY_REQUEST';
export const SEND_ENQUIRY_SUCCESS = 'app/ShoppingCart/SEND_ENQUIRY_SUCCESS';
export const SEND_ENQUIRY_ERROR = 'app/ShoppingCart/SEND_ENQUIRY_ERROR';

export const ADD_TO_CART = 'app/ShoppingCart/ADD_TO_CART';
export const REMOVE_FROM_CART = 'app/ShoppingCart/REMOVE_FROM_CART';
export const UPDATE_QUANTITY = 'app/ShoppingCart/UPDATE_QUANTITY';
export const CLEAR_CART = 'app/ShoppingCart/CLEAR_CART';
export const LOAD_CART_SUCCESS = 'app/ShoppingCart/LOAD_CART_SUCCESS';

// ================ Reducer ================ //

const initialState = {
  // ... other initial state from user's attachment if any e.g. lineItems related
  cartItems: [],
  error: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_LINE_ITEMS_REQUEST:
      return { ...state, fetchLineItemsInProgress: true, fetchLineItemsError: null, lineItems: null };
    case FETCH_LINE_ITEMS_SUCCESS:
      return { ...state, fetchLineItemsInProgress: false, lineItems: payload };
    case FETCH_LINE_ITEMS_ERROR:
      return { ...state, fetchLineItemsInProgress: false, fetchLineItemsError: payload };

    case SEND_ENQUIRY_REQUEST:
      return { ...state, sendEnquiryInProgress: true, sendEnquiryError: null };
    case SEND_ENQUIRY_SUCCESS:
      return { ...state, sendEnquiryInProgress: false };
    case SEND_ENQUIRY_ERROR:
      return { ...state, sendEnquiryInProgress: false, sendEnquiryError: payload };

    case ADD_TO_CART: {
      console.log('ADD_TO_CART payload:', payload);
      const existingItemIndex = state.cartItems.findIndex(
        item => item.listing.id.uuid === payload.listing.id.uuid
      );
      const stock = payload.listing.attributes.currentStock; // Assuming currentStock is a number or null

      if (existingItemIndex > -1) {
        const updatedCartItems = state.cartItems.map((item, index) => {
          if (index === existingItemIndex) {
            const currentQuantityInCart = Number(item.checkoutValues.quantity) || 0;
            const quantityBeingAdded = Number(payload.checkoutValues.quantity) || 0;
            let newQuantity = currentQuantityInCart + quantityBeingAdded;

            if (typeof stock === 'number' && newQuantity > stock) {
              newQuantity = stock; // Cap at available stock
            }
            return {
              ...item,
              checkoutValues: {
                ...item.checkoutValues,
                quantity: newQuantity,
              },
            };
          }
          return item;
        });
        return { ...state, cartItems: updatedCartItems, error: null };
      } else {
        let initialQuantity = Number(payload.checkoutValues.quantity) || 1;
        if (typeof stock === 'number' && initialQuantity > stock) {
          initialQuantity = stock; // Cap at available stock
        }
        // Prevent adding if stock is 0 and initial quantity is also 0 (or less)
        if (typeof stock === 'number' && stock === 0 && initialQuantity <= 0) {
            return { ...state, error: { message: 'Item is out of stock.' } };
        }
        if (initialQuantity <= 0) { // If stock allows, but requested 0 or less, default to 1 or don't add
            if (typeof stock === 'number' && stock > 0) initialQuantity = 1;
            else return { ...state, error: { message: 'Cannot add item with zero or negative quantity.'}};
        }


        const newPayload = {
          ...payload,
          checkoutValues: {
            ...payload.checkoutValues,
            quantity: initialQuantity,
          },
        };
        return { ...state, cartItems: [...state.cartItems, newPayload], error: null };
      }
    }
    case REMOVE_FROM_CART:
      return {
        ...state,
        cartItems: state.cartItems.filter(item => item.listing.id.uuid !== payload.id),
        error: null,
      };
    case UPDATE_QUANTITY: {
      const newQuantity = Number(payload.quantity);
      if (isNaN(newQuantity) || newQuantity < 0) {
        // If new quantity is invalid, do nothing or set error
        return { ...state, error: { message: 'Invalid quantity.' } };
      }

      return {
        ...state,
        cartItems: state.cartItems
          .map(item => {
            if (item.listing.id.uuid === payload.id) {
              const stock = item.listing.attributes.currentStock;
              let quantityToSet = newQuantity;
              if (typeof stock === 'number' && quantityToSet > stock) {
                quantityToSet = stock; // Cap at available stock
              }
              return {
                ...item,
                checkoutValues: { ...item.checkoutValues, quantity: quantityToSet },
              };
            }
            return item;
          })
          .filter(item => item.checkoutValues.quantity > 0), // Remove if quantity becomes 0
        error: null,
      };
    }
    case CLEAR_CART:
      return { ...state, cartItems: [], error: null };
    case LOAD_CART_SUCCESS:
      console.log('Reducer - LOAD_CART_SUCCESS payload:', payload.cartItems); // Log payload
      return { ...state, cartItems: payload.cartItems || [], error: null };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchTransactionLineItemsRequest = () => ({
  type: FETCH_LINE_ITEMS_REQUEST,
});

export const fetchTransactionLineItemsSuccess = lineItems => ({
  type: FETCH_LINE_ITEMS_SUCCESS,
  payload: lineItems,
});

export const fetchTransactionLineItemsError = error => ({
  type: FETCH_LINE_ITEMS_ERROR,
  payload: error,
  error: true,
});

export const sendEnquiryRequest = () => ({ type: SEND_ENQUIRY_REQUEST });

export const sendEnquirySuccess = () => ({ type: SEND_ENQUIRY_SUCCESS });

export const sendEnquiryError = e => ({
  type: SEND_ENQUIRY_ERROR,
  error: true,
  payload: e,
});

export const addToCart = item => ({
  type: ADD_TO_CART,
  payload: item, // expects { id, quantity, price, ...other item details }
});

export const removeFromCart = itemId => ({
  type: REMOVE_FROM_CART,
  payload: { id: itemId },
});

export const updateQuantity = (itemId, quantity) => ({
  type: UPDATE_QUANTITY,
  payload: { id: itemId, quantity },
});

export const clearCart = () => ({
  type: CLEAR_CART,
});

export const loadCartSuccess = cartItems => ({
  type: LOAD_CART_SUCCESS,
  payload: { cartItems },
});

// ================ Thunks ================ //

// Thunk to load cart from API or sessionStorage
export const loadCart = () => (dispatch, getState, sdk) => {
  const { currentUser } = getState().user;
  let rawCartData = [];

  if (currentUser && currentUser.profile && currentUser.profile.publicData && currentUser.profile.publicData.shoppingCart) {
    console.log('Loading cart from publicData.shoppingCart:', currentUser.profile.publicData.shoppingCart);
    rawCartData = currentUser.profile.publicData.shoppingCart;
  } else if (typeof window !== 'undefined' && window.sessionStorage && window.sessionStorage.getItem('shoppingCart')) {
    try {
      const sessionCart = window.sessionStorage.getItem('shoppingCart');
      console.log('Loading cart from sessionStorage:', sessionCart);
      rawCartData = JSON.parse(sessionCart);
    } catch (e) {
      console.error('Error parsing shopping cart from session storage', e);
      rawCartData = [];
    }
  }

  console.log('Raw cart data before parsing:', rawCartData);

  const parsedCartData = rawCartData.map(item => {
    try {
      const listing = JSON.parse(item.listing);
      const checkoutValues = JSON.parse(item.checkoutValues);

      if (typeof listing !== 'object' || typeof checkoutValues !== 'object') {
        throw new Error('Invalid item structure after parsing');
      }

      console.log('Parsed item:', { listing, checkoutValues });

      return { listing, checkoutValues };
    } catch (e) {
      console.error('Error parsing item in shopping cart', e, item);
      return null;
    }
  }).filter(item => item && item.listing && item.checkoutValues);

  console.log('Parsed cart data after filtering:', parsedCartData);

  dispatch(loadCartSuccess(parsedCartData));
};

// Thunk to save cart
export const saveCart = () => (dispatch, getState, sdk) => {
  const { cartItems } = getState().shoppingCart;
  const { currentUser } = getState().user;
  const cartToSave = cartItems.map(item => ({
    listing: JSON.stringify(item.listing),
    checkoutValues: JSON.stringify(serializeCheckoutValues(item.checkoutValues)),
  }));

  console.log('Cart to save:', cartToSave); // Log cartToSave content

  if (currentUser) {
    const currentPublicData = currentUser.attributes.profile.publicData || {};
    const publicData = { ...currentPublicData, shoppingCart: cartToSave };

    // Use the 'post' utility for API call
    post('/api/update-profile', { publicData })
      .then(() => {
        console.log('Shopping cart saved to user profile via API');
        // Optionally, dispatch an action to confirm save, or update currentUser in Redux store
        // For example, if the API returns the updated user:
        // dispatch(currentUserShowSuccess(updatedUserFromResponse)); 
      })
      .catch(e => {
        console.error('Error saving shopping cart to user profile via API:', e);
        // Potentially dispatch an error action
        // dispatch(saveCartError(e));
      });
  } else if (typeof window !== 'undefined' && window.sessionStorage) {
    try {
      window.sessionStorage.setItem('shoppingCart', JSON.stringify(cartToSave)); // Use cartToSave
    } catch (e) {
      console.error('Error saving shopping cart to session storage', e);
    }
  }
};

export const fetchTransactionLineItems = params => (dispatch, getState, sdk) => {
  dispatch(fetchTransactionLineItemsRequest());

  const { orderData, listingId, isOwnListing } = params;

  return sdk.transactionLineItems
    .query({ ...orderData, listingId, isOwnListing })
    .then(response => {
      const lineItems = response.data.data;
      dispatch(fetchTransactionLineItemsSuccess(lineItems));
    })
    .catch(e => {
      dispatch(fetchTransactionLineItemsError(storableError(e)));
      throw e;
    });
};

export const sendEnquiry = params => (dispatch, getState, sdk) => {
  dispatch(sendEnquiryRequest());
  const { message, listing, customValues = {} } = params;

  return sdk.messages
    .send({
      type: 'enquiry',
      content: message,
      listingId: listing.id,
      customValues,
    })
    .then(response => {
      const messageId = response.data.data.id;
      const entity = denormalisedResponseEntities(response);
      const message = entity[0];

      dispatch(sendEnquirySuccess());
      return { messageId, message };
    })
    .catch(e => {
      dispatch(sendEnquiryError(storableError(e)));
      throw e;
    });
};

export const addItemAndSave = item => dispatch => {
  dispatch(addToCart(item));
  dispatch(saveCart());
};

export const removeItemAndSave = itemId => dispatch => {
  dispatch(removeFromCart(itemId));
  dispatch(saveCart());
};

export const updateQuantityAndSave = (itemId, quantity) => dispatch => {
  dispatch(updateQuantity(itemId, quantity));
  dispatch(saveCart());
};

export const clearCartAndSave = () => dispatch => {
  dispatch(clearCart());
  dispatch(saveCart());
};

function serializeCheckoutValues(checkoutValues) {
  if (!checkoutValues) return checkoutValues;
  // Recursively convert all Date objects to ISO strings
  return JSON.parse(JSON.stringify(checkoutValues, (key, value) => {
    if (value instanceof Date) return value.toISOString();
    // If using Moment.js, add: if (value && value._isAMomentObject) return value.toISOString();
    return value;
  }));
}
